module.exports = __webpack_public_path__ + "img/logo.head.b9020498.png";